export default {
    login: {
        userName: "Nom d'Usuari",
        password: "Contrasenya",
        login: "INICIAR SESSIÓ"
    },
    navbar: {
        home: "Principal",
        contracts: "Contractes",
        settings: "Configuració",
        info: "Ajuda"
    },
    header: {
        home: "PRINCIPAL",
        contracts: "CONTRACTES",
        settings: "CONFIGURACIÓ",
        info: "AJUDA",
        contract: "CONTRACTE",
        addService: "AFEGIR SERVEI",
        service: "SERVEI",
    },
    home: {
        hello: "Hola"
    },
    contracts: {
        active: "Actius",
        suspended: "Baixes",
        services: "Serveis",
        noSuspendedContracts: "No hi han contractes de baixa",
        noServices: "No hi han serveis pendents associats a aquest contracte",
        noPressupost: "No hi ha cap pagament pendent en aquest contracte",
        renovar: "Renovar contracte"
    },
    settings: {
        user: "USUARI",
        closeSession: "Tancar Sessió",
        settings: "CONFIGURACIÓ",
        appLanguage: "Idioma de l'aplicació",
        confirmationText: "Estàs segur que vols sortir de la teva sessió?"
    },
    info: {
        pagat: "Pagat"
    },
    addService: {
        addTitle: "Demanar un Servei",
        editTitle: "Servei",
        entrance: "Entrada al càmping",
        exit: "Sortida del càmping",
        pickupAtParking: "Recollir caravana al pàrquing",
        deliveryAtParking: "Lliurar caravana al pàrquing",
        doneText: "Fet",
        cancelText: "Cancel·lar",
        transportDate: "Data del Transport",
        camping: "Càmping",
        selectCamping: "-- Selecciona --",
        parcel: "Parcel·la",
        selectParcel: "Indica la parcel·la",
        save: "Guardar",
		payment: "Pagament",
		paymentTitle: "Pagament del servei",
		servicePaymentConfirm: "Estàs segur que vols procedir al pagament d'aquest servei?",
        toastMessage: "Has de omplir tots els camps per guardar!",

        requestService: "Demanar servei",
        serviceSummary: "Resum servei",
        total: "Total",
        paidService: "Servei pagat",
        transactionCompleted: "Transacció finalitzada correctament",
        serviceConfirm: "Estàs segur que vols demanar aquest servei?",
        loading: "Demanant servei...",

        reserveNum: "Número de reserva",
        selectReserveNum: "Indica el número",
        availableHoursInfo: "Horari disponible per al transport: de {start} a {end}.",

        toastMessage2: "Per demanar un servei per abans de les pròximes 48 hores posa't en contacte amb nosaltres."
    },
    service: {
        pending: "Pendent",
        completed: "Finalitzat",
        requestCompleted: "El servei s'ha demanat correctament"
    },
    contract: {
        entrance: "Entrada",
        exit: "Sortida",
        registration: "Matrícula",
        initialDate: "Data inicial",
        finalDate: "Data final",
        zone: "Zona",
        parkType: "Tipus de pàrquing",
        pendingServices: "Serveis Pendents",
        completedServices: "Serveis Finalitzats",
        pendingPressupost: "Pagaments pendents",
        pendingPressupostS: "Pagament pendent",
        pay: "Pagar",
        acceptConditions: "Acceptar els termes i condicions",
        acceptConditionsTitle: "Termes i condicions",
        contractNumberRequired: "És necessari indicar el número de reserva per tal de poder garantir el transport"
    },
    interceptors: {
        noAuthorized: "Usuari no autoritzat"
    },
    payment: {
        confirmed: "Pagament confirmat",
        confirmedExtended: "El pagament s'ha realitzat amb èxit",
        article: "Article",
        price: "Total",
        informEmail: "Rebràs un correu electròniques amb les dades del pagament",
        goBack: "Tornar enrera",
        denied: "Pagament denegat",
        deniedExtended: "Hi ha hagut algun problema amb el pagament",
        deniedInfo: "Torna-ho a intentar en uns minuts, i si el problema persisteix, posa't en contacte amb nosaltres"
    }
};